// extracted by mini-css-extract-plugin
export default {"container":"globalError_container__HRYtt"};